import {Component, EventEmitter, Input, Output} from '@angular/core';
import {I18nMessage} from '@app/shared/api/model/i18n';
import {NgbActiveModal, NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

export interface ExportModalData {
  message: I18nMessage | null;
  isExportReady: boolean;
  isExportLoading: boolean;
  progressDecimal: number;
  generateDisabledReason: I18nMessage | null;
  loadingMessage: I18nMessage | null;
}

@Component({
  selector: 'app-export-modal',
  templateUrl: './export-modal.component.html',
  standalone: false
})
export class ExportModalComponent implements ExportModalData {
  @Input() message: I18nMessage | null = null;
  @Input() isExportReady = false;
  @Input() isExportLoading = false;
  @Input() progressDecimal = 0;
  @Input() generateDisabledReason: I18nMessage | null = null;
  @Input() loadingMessage: I18nMessage | null = null;
  @Output() generateTriggered = new EventEmitter<void>();
  @Output() downloadTriggered = new EventEmitter<void>();

  constructor(public modal: NgbActiveModal) {}

  triggerGenerate(): void {
    this.generateTriggered.emit();
  }

  triggerDownload(): void {
    this.downloadTriggered.emit();
  }

  static openInModal(modalService: NgbModal, modalData: Partial<ExportModalData>, options?: NgbModalOptions) {
    const modalRef = modalService.open(ExportModalComponent, {size: 'md', ...options});
    const component: ExportModalComponent = modalRef.componentInstance;
    component.message = modalData.message ?? component.message;
    component.isExportReady = modalData.isExportReady ?? component.isExportReady;
    component.isExportLoading = modalData.isExportLoading ?? component.isExportLoading;
    component.progressDecimal = modalData.progressDecimal ?? component.progressDecimal;
    component.generateDisabledReason = modalData.generateDisabledReason ?? component.generateDisabledReason;
    component.loadingMessage = modalData.loadingMessage ?? component.loadingMessage;
    return modalRef;
  }
}
